import React from "react";
import Icon from "./OBJECT.svg";

const NoPermission = () => {
  return (
    <div className="flex flex-col items-center justify-center flex-1 p-4 text-center">
      <img src={Icon} alt="no permission icon" />
      <h1 className="text-2xl font-bold text-center mt-4">
        УПС! сізге рұқсат жоқ
      </h1>
      <p className="text-center text-lg text-gray-700 max-w-3xl mt-2">
        UstazKids.kz есептік жазбасын алу үшін өтінім қалдырыңыз, содан кейін
        сізге платформа қол жетімді болады.
      </p>

      <a
        href="https://wa.me/+77776655965"
        target="_blank"
        rel="noopener noreferrer"
        className="bg-[#F3DA6D] text-base text-[#674DA2] py-2 px-10 rounded-xl mt-10 uppercase inline-block"
      >
        өтінім қалдыру
      </a>
    </div>
  );
};

export default NoPermission;
